import profileImg from './portrait.jpg';

function About() {
    return (
      <section id="about" className="about">
        <img src={profileImg} alt="Profile" className="profile-img" />
        <h2>About Me</h2>
        <p>
        I'm a Computer Science student at UC Davis working at the intersection of machine learning and software engineering. My favorite project so far is a pneumonia detector that classifies chest X-rays and uses Grad-CAM to show which regions drove each prediction, because a model doctors can't interpret isn't one they'll trust.
        I'm looking for internship opportunities in applied ML where I can work on problems with real stakes and learn from people who work rigorously.
        </p>
      </section>
    );
  }
  
  export default About;